import { useLayoutEffect, useRef, useState } from "react";

export default function useGetChildDims<T extends Element = HTMLDivElement>() {
  const ref = useRef<T>(null);
  const [dims, setDims] = useState({ w: 0, h: 0 });
  useLayoutEffect(() => {
    if (!ref.current) return;
    const el = ref.current;
    const observer = new ResizeObserver(([entry]) => {
      const { inlineSize: w, blockSize: h } = entry.contentBoxSize[0];
      setDims({ w, h });
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  return { ref, dims };
}